import Wrapper from "./List.styled";

const List = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default List;
